import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: 'button, button[mat-button], a[mat-button]',
})
export class ViButtonDirective {
  @HostBinding('class.vi-button') viButton = true;

  @HostBinding('class.no-uppercase') noUppercase: boolean;

  @HostBinding('class.large') isLarge: boolean;

  @Input('uppercase')
  set uppercase(value: boolean) {
    this.noUppercase = !value;
  }

  @Input('large')
  set large(value: boolean) {
    this.isLarge = value;
  }
}
